// extracted by mini-css-extract-plugin
module.exports = {"allWrap":"Dashboard_allWrap__iJSbl","topContainer":"Dashboard_topContainer__3c8JT","card":"Dashboard_card__2h-ot"};